import { Box, styled } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { AI_GRADIENT_CSS } from 'common/constants/ai';

export const PDFPageSelectionControlsContainer = styled(Box, {
  shouldForwardProp: prop => prop !== '$allowPageSelection' && prop !== '$isPopped',
})<{ $allowPageSelection: boolean; $isPopped?: boolean; }>(
  ({ $allowPageSelection }) => ({
    borderBottom: '1px solid #e0e0e0',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
    width: 'auto',
    height: 'fit-content',
    gap: '30px',
    flexWrap: 'wrap',
    alignContent: 'space-around',
    paddingTop: '6px',
    paddingBottom: '6px',
    paddingLeft: '50px',
    position: $allowPageSelection ? 'sticky' : 'relative',
    top: $allowPageSelection ? 0 : undefined,
    zIndex: $allowPageSelection ? 10000 : undefined,
  })
);

export const actionsBoxSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const acceptAllButtonSx: SxProps<Theme> = {
  background: AI_GRADIENT_CSS,
  color: 'white',
  fontWeight: 600,
  textTransform: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: 0.75,
  padding: '6px 12px !important',
  fontSize: '1rem !important',
  '&:hover': { filter: 'brightness(0.9)', background: AI_GRADIENT_CSS },
  '&.Mui-disabled': { background: AI_GRADIENT_CSS, opacity: 0.45, color: 'white' },
};

export const acceptAllIconSx: SxProps<Theme> = {
  width: 18,
  height: 18,
};
